<app-error-notification [expire]="expire"></app-error-notification>
<!-- <div appThemeSwticher [mode]='mode' fxLayout="column" fxLayoutAlign="center stretch" fxLayoutGap="0px" fxFlexFill>
	<ng-container *ngIf="!localeChanges">
		<div [ngClass]="(isLogin) ? (detectDevice?.resolutionState$?.value?.deviceType === 'mobile') ? '' : 'lett-nav' : ''">
			<ng-container *ngIf="isLogin">
				<header>
					<app-header [sideNavState]="onSideNavChange"></app-header>
				</header>
			</ng-container>
		</div>
		<ng-container *ngIf="isLogin">
			<mat-sidenav #sidenav mode="side" opened>
				<app-sidebar [sidenav]="sidenav" [sideNavState]="onSideNavChange"></app-sidebar>
			</mat-sidenav>
		</ng-container>
		<mat-sidenav-container fxFlex="1 0">
			<mat-sidenav-content class="site-content" fxLayout="column" fxLayoutAlign="space-between stretch"
				[ngClass]="(isLogin) ? (detectDevice?.resolutionState$?.value?.deviceType === 'mobile') ? '' : 'lett-nav' : ''" (scroll)="onScroll($event)">
				<ng-container *ngIf="isLogin">
					<div id="scrollReset"></div>
				</ng-container>
				<div class="container">
					<router-outlet></router-outlet>
					<ng-container *ngIf="loader">
						<div fxLayoutAlign="center start" class="page-loader">
							<div class="loader"></div>
						</div>
					</ng-container>
				</div>
			</mat-sidenav-content>
		</mat-sidenav-container>
	</ng-container>
	<loader [loader]="localeChanges" [type]="'updater'"></loader>
</div> -->
<!-- <div appThemeSwticher [mode]='mode' fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="0px" fxFlexFill>
	<ng-container *ngIf="!localeChanges">
		<div>
			<ng-container *ngIf="isLogin">
				<header>
					<app-header [sideNavState]="onSideNavChange"></app-header>
				</header>
			</ng-container>
		</div>
		<div fxFlex="1 1" fxLayout="row" fxLayoutAlign="start stretch" fxLayoutGap="0px" class="site-container">
			<ng-container *ngIf="isLogin">
				<app-sidebar fxFlex="0 0 75px" fxFlex.xs="0 0 45px" [sideNavState]="onSideNavChange"></app-sidebar>
			</ng-container>
			<div fxFlex="1 1" class="site-content">
				<ng-container *ngIf="isLogin">
					<div id="scrollReset"></div>
				</ng-container>
				<div class="container">
					<router-outlet></router-outlet>
					<ng-container *ngIf="loader">
						<div fxLayoutAlign="center start" class="page-loader">
							<div class="loader"></div>
						</div>
					</ng-container>
				</div>
</div>
</div>
</ng-container>
<loader [loader]="localeChanges" [type]="'updater'"></loader>
</div> -->

<div appThemeSwticher [mode]='mode' fxLayout="column" fxLayoutAlign="center stretch" fxLayoutGap="0px" fxFlexFill>
	<ng-container *ngIf="!localeChanges">
		<ng-container *ngIf="isLogin && !setupScreen">
			<header>
				<app-header [sideNavState]="onSideNavChange"></app-header>
			</header>
		</ng-container>
		<mat-sidenav-container fxFlex="1 0" class="side-nav-container">
			<mat-sidenav #sidenav mode="over" class="main-side-nav"
				[ngClass]="{'full-screen': detectDevice?.resolutionState$?.value?.deviceType === 'mobile' && isMenuActive}">
				<div class="sidenav" fxFlex="1 0" fxLayout="column" fxLayoutAlign="space-between stretch">
					<div fxLayout="row" fxLayoutAlign="start stretch">
						<div class="menu-list" fxFlex="0 0 76px" fxFlex.xs="0 0 45px" fxLayout="column"
							fxLayoutAlign="start stretch" fxLayoutGap="10px" fxLayoutGap.xs="5px">
							<ng-container *ngFor="let menu of menuGroups">
								<ng-container *ngIf="!menu?.hasOwnProperty('isBurger') || menu?.isBurger">
									<div class="menu-item cursor-pointer" fxLayout="column" fxLayoutAlign="center stretch"
										[ngClass]="{'active': menu?.active}" (click)="showChildMenu('click',menu)"
										(mouseover)="showChildMenu('hover',menu)">
										<div class="menu-holder" fxLayout="column" fxLayoutGap="0px" fxLayoutAlign="center center">
											<div class="menu-icon" fxLayoutAlign="center center">
												<ng-container *ngIf="menu?.svgIcon">
													<mat-icon [svgIcon]="menu?.svgIcon"></mat-icon>
												</ng-container>
												<ng-container *ngIf="menu?.icon">
													<mat-icon>{{menu?.icon}}</mat-icon>
												</ng-container>
											</div>
											<div class="menu-caption" fxHide.xs>
												{{menu?.title}}
											</div>
										</div>
									</div>
								</ng-container>
							</ng-container>
						</div>
						<ng-container *ngFor="let menu of menuGroups">
							<ng-container *ngIf="menu?.active">
								<div class="menu-view" fxFlex="1 1 320px" fxFlex.xs="100%" fxLayout="column"
									fxLayoutAlign="start stretch" fxLayoutGap="8px">
									<h3 class="menu-view-title">
										{{menu?.title}}
									</h3>
									<div fxFlex="1 1" class="menu-view-list" fxLayout="column" fxLayoutAlign="start stretch"
										fxLayoutGap="3px">

										<!-- <ng-container *ngIf="menu?.key === 'engage'">
											<div class="menu-view-list-item" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
												<div fxLayout="column" fxLayout="start start">
													<span class="body-text">{{locale.translate('got_some_thoughts_knowledge_to_share')}}
													</span>
													<button type="button" mat-raised-button>{{locale.translate('share_a_knowledge_bead')}}</button>
												</div>
											</div>
											<div class="menu-view-list-item" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
												<div fxLayout="column" fxLayout="start start">
													<span class="body-text">{{locale.translate('want_your_workgroups_to_share_their_knowledge')}}
													</span>
													<button type="button" mat-raised-button>{{locale.translate('assign_a_knowledge_card')}}</button>
												</div>
											</div>
											<div class="menu-view-list-item" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
												<div fxLayout="column" fxLayout="start start">
													<span class="body-text">{{locale.translate('want_to_share_some_achievement')}}
													</span>
													<button type="button" mat-raised-button>{{locale.translate('recognize')}}</button>
												</div>
											</div>
										</ng-container>

										<ng-container *ngIf="menu?.key === 'learn'">
											<div class="menu-view-list-item" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
												<div fxLayout="column" fxLayout="start start">
													<span class="body-text">{{locale.translate('got_a_question')}}
													</span>
													<button type="button" mat-raised-button>{{locale.translate('ask')}}</button>
												</div>
											</div>
											<div class="menu-view-list-item" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
												<div fxLayout="column" fxLayout="start start">
													<span class="body-text">{{locale.translate('acquired_new_skills_certifications')}}
													</span>
													<button type="button" mat-raised-button>{{locale.translate('record_learning')}}</button>
												</div>
											</div>
											<div class="menu-view-list-item" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
												<div fxLayout="column" fxLayout="start start">
													<span class="body-text">{{locale.translate('Do_you_your_team_need_training')}}
													</span>
													<button type="button" mat-raised-button>{{locale.translate('register_training_need')}}</button>
												</div>
											</div>
										</ng-container>

										<ng-container *ngIf="menu?.key === 'workgroups'">
											<div class="menu-view-list-item" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
												<div fxLayout="column" fxLayout="start start">
													<span class="body-text">{{locale.translate('has_new_member_joined_your_team')}}
													</span>
													<button type="button" mat-raised-button>{{locale.translate('send_an_invite')}}</button>
												</div>
											</div>
											<div class="menu-view-list-item" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
												<div fxLayout="column" fxLayout="start start">
													<span class="body-text">{{locale.translate('has_your_workgroup_structure_changed')}}
													</span>
													<button type="button" mat-raised-button>{{locale.translate('manage_workgroups')}}</button>
												</div>
											</div>
										</ng-container>

										<ng-container *ngIf="menu?.key === 'resources'">
											<div class="menu-view-list-item" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
												<div fxLayout="column" fxLayout="start start">
													<button type="button" mat-raised-button>{{locale.translate('create')}}</button>
													<button type="button" mat-raised-button>{{locale.translate('manage')}}</button>
												</div>
											</div>
										</ng-container>

										<ng-container *ngIf="menu?.key === 'people'">
											<div class="menu-view-list-item" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
												<div fxLayout="column" fxLayout="start start">
													<button type="button" mat-raised-button>{{locale.translate('search_people')}}</button>
												</div>
											</div>
											<div class="menu-view-list-item" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
												<div fxLayout="column" fxLayout="start start">
													<button type="button" mat-raised-button>{{locale.translate('endorse_skills')}}</button>
												</div>
											</div>
										</ng-container> -->

										<ng-container *ngFor="let childMenu of menu?.menuList">
											<ng-container *ngIf="!childMenu?.hasOwnProperty('isBurger') || childMenu?.isBurger">
												<div class="menu-view-list-item" fxLayout="column" fxLayoutAlign="start stretch"
													fxLayoutGap="10px">
													<div fxLayout="column" fxLayout="start start" (click)="routerNav(childMenu)"
														[ngClass]="{'cursor-pointer': childMenu?.link}">
														<span class="caption">{{childMenu?.title}}
														</span>
													</div>
												</div>
											</ng-container>
										</ng-container>

										<ng-container *ngIf="[null,undefined].includes(menu?.menuList)">
											<div class="menu-view-list-item" fxLayout="column" fxLayoutAlign="start stretch"
												fxLayoutGap="10px">
												<div fxLayout="column" fxLayout="start start" (click)="routerNav(menu)"
													[ngClass]="{'cursor-pointer': menu?.link}">
													<span class="caption">{{menu?.title}}
													</span>
												</div>
											</div>
										</ng-container>

									</div>
								</div>
							</ng-container>
						</ng-container>
					</div>
				</div>
			</mat-sidenav>
			<mat-sidenav-content class="side-nav-content" (scroll)="onScroll($event)"
				[ngStyle]="{'overflow-y': (isLogin && !setupScreen) ? '' : 'auto'}">
				<ng-container *ngIf="isLogin">
					<div id="scrollReset"></div>
				</ng-container>
				<div fxLayout="row" class="site-content">
					<ng-container
						*ngIf="isLogin && detectDevice?.resolutionState$?.value?.deviceType !== 'mobile' && !setupScreen">
						<app-sidebar></app-sidebar>
					</ng-container>
					<div fxFlex="1 1 auto" class="container">
						<ng-container *ngIf="isLogin && !setupScreen">
							<!-- <mat-divider class="custom-divider sticky-divider"></mat-divider> -->
						</ng-container>
						<router-outlet></router-outlet>
					</div>
				</div>
			</mat-sidenav-content>
		</mat-sidenav-container>

		<ng-container *ngIf="loader">
			<div fxLayout="column" fxLayoutAlign="center center" class="page-loader" fxLayoutGap="10px">
				<!-- <div class="loader"></div>-->
				<div class="loader">
					<!-- <svg viewBox="0 0 64 64">
						<g>
							<defs>
								<linearGradient id="sGD" gradientUnits="userSpaceOnUse" x1="55" y1="46" x2="2" y2="46">
									<stop offset="0.1" class="stop1"></stop>
									<stop offset="1" class="stop2"></stop>
								</linearGradient>
							</defs>
							<g stroke-width="4" stroke-linecap="round" fill="none" transform="rotate(196.586 32 32)">
								<path stroke="url(#sGD)" d="M4,32 c0,15,12,28,28,28c8,0,16-4,21-9"></path>
								<path d="M60,32 C60,16,47.464,4,32,4S4,16,4,32"></path>
								<animateTransform values="0,32,32;360,32,32" attributeName="transform" type="rotate"
									repeatCount="indefinite" dur="750ms"></animateTransform>
							</g>
						</g>
					</svg> -->
					<img class="main-loader-img" src="assets/img/loading-bw4.gif">
				</div>
				<p class="loading_text">{{locale.translate("loading_text")}}</p>
			</div>
		</ng-container>
	</ng-container>
	<loader [loader]="localeChanges" [type]="'updater'"></loader>
</div>
